import { render, staticRenderFns } from "./return_detail.vue?vue&type=template&id=949af12c&scoped=true"
import script from "./return_detail.vue?vue&type=script&lang=js"
export * from "./return_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949af12c",
  null
  
)

export default component.exports